/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : RoleType.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import {
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import CommonBreadcrumbs from "../../components/customComponentsV2/common/Breadcrumbs/CommonBreadcrumbs";
import AddButtonV2 from "../../components/customComponentsV2/common/button/AddButtonV2";
import CustomSearchbarWithApiV2 from "../../components/customComponentsV2/common/searchBar/CustomSearchbarWithApiV2";
import CustomDataGridV2 from "../../components/customComponentsV2/common/datagrid/CustomDataGridV2";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddEditRoleType from "./roletype/AddEditRoleType";
import { useDispatch, useSelector } from "react-redux";
import { HandleApiActions } from "../../redux/actions";
import roletypeActions from "../../redux/actions/roletypeActions";
import deleteIcon from "../../assets/delete_icon.png";
import CloseIcon from "@mui/icons-material/Close";
import CustomButtonV2 from "../../components/customComponentsV2/common/button/CustomButtonV2";
import ChipsSelectField from "../../components/customComponentsV2/common/select/ChipsSelectField";
import policiesActions from "../../redux/actions/policiesActions";
import AttachmentIcon from "@mui/icons-material/Attachment";
import dayjs from "dayjs";
import CustomDialogBoxV2 from "../../components/customComponentsV2/common/customDialogBox/CustomDialogBoxV2";

function RoleType() {
  const dispatch = useDispatch();
  const roleTypesAll = useSelector(
    (state) => state.roleTypeReducers.roleTypesAll,
  );
  const roleTypeSelected = useSelector(
    (state) => state.roleTypeReducers.roleType,
  );
  const policies = useSelector((state) => state.policyReducer.policies);

  const [openAddEditRoleTypeDialog, setOpenAddEditRoleTypeDialog] =
    useState(false);
  const [openAddEditRoleTypeDialogEdit, setOpenAddEditRoleTypeDialogEdit] =
    useState(false);
  const [openActionDetailsDialog, setOpenActionDetailsDialog] = useState(false);
  const [selectedRoleType, setSelectedRoleType] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedPolicies, setSelectedPolicies] = useState([]);
  const [roleTypeCount, setRoleTypeCount] = useState("");

  const [policyDefIds, setPolicyDefIds] = useState("");

  const [page, setPage] = useState(1);
  const rowsPerPage = 25;
  const [triggerRoleType, setTriggerRoleType] = useState(false);

  const fetchRoleTypes = async () => {
    await Promise.resolve(
      dispatch(
        HandleApiActions({
          ...roletypeActions.get_all_roletype,
          params: { page_size: rowsPerPage, page: page },
        }),
      ),
    );
  };

  useEffect(() => {
    dispatch(
      HandleApiActions({
        ...policiesActions.get_policies,
        params: {
          limit: 100,
          offset: 1,
        },
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(
      HandleApiActions({
        ...roletypeActions.get_all_roletype,
        params: { page_size: rowsPerPage, page: page },
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (roleTypesAll?.data?.meta?.total_count !== undefined) {
      setRoleTypeCount(roleTypesAll.data.meta.total_count);
    }
  }, [roleTypesAll]);

  const handleTableRowClick = async (data) => {
    console.log("---datadatadatadata----", data);
    try {
      const resp = await Promise.resolve(
        dispatch(
          HandleApiActions({
            ...roletypeActions.get_roletype_by_id,
            api_name: `/UCM/role-types/${data?.row?.role_type_id}`,
          }),
        ),
      );
      console.log("respresprwrwfsadassdadfa", resp);
      if (!resp?.error) {
        setSelectedRoleType(resp?.data);
      }
    } catch (error) {
      console.error("Error fetching role type details:", error);
    }

    setOpenAddEditRoleTypeDialogEdit(true);
  };
  const handleOpenActionDetailsDialog = async (data) => {
    console.log("Action Details Data", data);
    setSelectedRoleType(data?.row);
    setOpenActionDetailsDialog(true);
    const resp = await Promise.resolve(
      dispatch(
        HandleApiActions({
          ...roletypeActions.get_roletype_by_id,
          api_name: `/UCM/role-types/${data?.row?.role_type_id}`,
        }),
      ),
    );

    if (resp?.data?.policies?.length > 0) {
      setSelectedPolicies(
        resp?.data?.policies?.map((data) => {
          return {
            label: data?.policy_key,
            value: data?.policy_def_id,
            actions:
              data?.domains_actions?.flatMap(
                (domains) => domains?.actions || [],
              ) || [],
          };
        }),
      );
    }
  };
  console.log("roleTypeSelectedroleTypeSelected", roleTypeSelected);
  console.log("selectedPolicies", selectedPolicies);

  const listOfPolicies = useMemo(() => {
    return policies?.data?.policies;
  }, [policies?.data]);

  const tableRowsData = useMemo(() => {
    return roleTypesAll?.data?.roleTypes?.map((data, idx) => ({
      id: (page - 1) * rowsPerPage + idx + 1,

      display_name: data?.display_name,
      description: data?.description,
      is_active: data?.is_active,
      is_system: data?.is_system,

      created_at: dayjs(data.created_at)?.format("DD MMMM YYYY, hh:mm A") || "",

      ...data,
    }));
  }, [roleTypesAll, page, rowsPerPage]);

  console.log("roleTypeAllroleTypeAllroleTypeAllroleTypeAll", roleTypesAll);
  const COLUMNS = [
    {
      field: "id",
      headerName: "S.No",
      flex: 0.4,
      minWidth: 60,
      maxWidth: 80,
      filterable: false,
      sortable: false,
    },
    {
      field: "display_name",
      headerName: "Display Name",
      flex: 1,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
    },
    {
      field: "created_at",
      headerName: "Created At",
      flex: 1,
    },
    {
      field: "is_system",
      headerName: "Type",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        const isSystem = params.value;

        return (
          <Chip
            size="small"
            label={isSystem ? "System" : "Custom"}
            variant={isSystem ? "outlined" : "filled"}
            color={isSystem ? "default" : "success"}
            sx={{
              borderRadius: 0,
            }}
          />
        );
      },
    },
    {
      field: "is_active",
      headerName: "Status",

      renderCell: (params) => {
        const value = params.value;

        return (
          <Chip
            size="small"
            label={value ? "Active" : "Inactive"}
            variant={value ? "filled" : "outlined"}
            color={value ? "success" : "default"}
            sx={{ borderRadius: 0 }}
          />
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      width: 160,
      renderCell: (params) => {
        const isSystem = params.row.is_system;

        return (
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <Tooltip
              title={
                isSystem
                  ? "System role types cannot be edited"
                  : "Edit role type"
              }
              arrow
            >
              <span>
                <IconButton
                  size="small"
                  sx={{ color: "#000000", p: 0.5 }}
                  disabled={isSystem}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleTableRowClick(params);
                  }}
                >
                  <BorderColorIcon fontSize="inherit" sx={{ fontSize: 19 }} />
                </IconButton>
              </span>
            </Tooltip>

            <Tooltip title="Delete Role">
              <span>
                <IconButton
                  disabled={isSystem}
                  onClick={() => {
                    setSelectedRoleType(params.row);
                    setOpenDeleteDialog(true);
                  }}
                >
                  <img src={deleteIcon} alt="Delete" width={18} />
                </IconButton>
              </span>
            </Tooltip>

            <Tooltip
              title={
                isSystem
                  ? "Policies for system role types are managed by the platform"
                  : "Manage policies"
              }
              arrow
            >
              <span>
                <IconButton
                  size="small"
                  sx={{ color: "#000000", p: 0.5 }}
                  disabled={isSystem}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenActionDetailsDialog(params);
                  }}
                >
                  <AttachmentIcon fontSize="inherit" sx={{ fontSize: 19 }} />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  const handleAttach = (data) => {
    console.log("Handle Attach", data);

    let reqObj = {
      policyDefIds: [data],
      reason: "Attaching Policy",
    };

    dispatch(
      HandleApiActions({
        ...roletypeActions.attach_policy_roletype,
        api_name: `/UCM/role-types/${selectedRoleType?.role_type_id}/policies`,
        params: reqObj,
        show_toast: true,
      }),
    ).then(async () => {
      const resp = await Promise.resolve(
        dispatch(
          HandleApiActions({
            ...roletypeActions.get_roletype_by_id,
            api_name: `/UCM/role-types/${selectedRoleType?.role_type_id}`,
          }),
        ),
      );
      if (!resp?.error) {
        console.log(
          "respdbsicgshsdkovbdsjvdshvldssdv",
          resp?.data?.rolePolicies,
        );
        setSelectedPolicies(
          resp?.data?.policies?.map((data) => {
            return {
              label: data?.policy_key,
              value: data?.policy_def_id,
              actions: data?.actions,
            };
          }),
        );
      }
    });
  };

  const handleDetach = (data) => {
    console.log("Handle Detach", data);
    let reqObj = {
      policyDefIds: [data],
      reason: "Attaching Policy",
    };

    dispatch(
      HandleApiActions({
        ...roletypeActions.detach_policy_roletype,
        api_name: `/UCM/role-types/${selectedRoleType?.role_type_id}/policies`,
        params: reqObj,
        show_toast: true,
      }),
    ).then(async () => {
      const resp = await Promise.resolve(
        dispatch(
          HandleApiActions({
            ...roletypeActions.get_roletype_by_id,
            api_name: `/UCM/role-types/${selectedRoleType?.role_type_id}`,
          }),
        ),
      );
      if (!resp?.error) {
        console.log(
          "respdbsicgshsdkovbdsjvdshvldssdv",
          resp?.data?.rolePolicies,
        );
        setSelectedPolicies(
          resp?.data?.policies?.map((data) => {
            return {
              label: data?.policy_key,
              value: data?.policy_def_id,
              actions: data?.actions,
            };
          }),
        );
      }
    });
  };
  console.log("selectedRoleTypeSelectedRoleType", selectedRoleType);
  return (
    <div>
      <Box sx={{ p: 1 }}>
        <Box>
          <CommonBreadcrumbs
            items={[
              { label: "Settings" },
              { label: "Accounts & Access" },
              { label: "Role Type" },
            ]}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 1,
          }}
        >
          <Box>
            <CustomSearchbarWithApiV2
              apiAction={{ ...roletypeActions.get_all_roletype }}
              params={{ page_size: rowsPerPage, page: page }}
              searchKey="name"
              size="small"
              type="text"
              variant="outlined"
              placeholder="Search Role Type..."
              valueError={""}
              isMultiline={false}
              minRows={1}
              maxRows={3}
              disabled={false}
              triggerApi={triggerRoleType}
              txtFldStyle={{
                width: "100%",
              }}
              getDataOnSearch={(data, resp) => {
                console.log("Search datadata", data);
                setRoleTypeCount(data?.meta?.total_count);
              }}
            />
          </Box>
          <Box sx={{ mt: 1, mb: 1 }}>
            <AddButtonV2
              handleOnClick={() => setOpenAddEditRoleTypeDialog(true)}
            />
          </Box>
        </Box>
        <Box
          sx={{
            height: "76vh",
            width: "100%",
            display: "flex",
            flexDirection: "column",

            mt: 1,
          }}
        >
          <CustomDataGridV2
            rows={tableRowsData}
            columns={COLUMNS}
            onRowClick={handleTableRowClick}
            page={page}
            isMultiLine={true}
            rowsPerPage={rowsPerPage}
            totalItems={roleTypeCount}
            showPagination={roleTypeCount > 0}
            handlePageChange={(newPage) => setPage(newPage)}
          />
        </Box>
      </Box>
      {openAddEditRoleTypeDialog && (
        <AddEditRoleType
          open={openAddEditRoleTypeDialog}
          onClose={() => setOpenAddEditRoleTypeDialog(false)}
          title="Add Role Type"
        />
      )}
      {openAddEditRoleTypeDialogEdit && (
        <AddEditRoleType
          open={openAddEditRoleTypeDialogEdit}
          onClose={() => setOpenAddEditRoleTypeDialogEdit(false)}
          
          setTriggerRoleType={setTriggerRoleType}
          title="Update Roletype"
          selectedRoleType={selectedRoleType}
        />
      )}
      {openActionDetailsDialog && (
        <Dialog
          open={openActionDetailsDialog}
          onClose={() => setOpenActionDetailsDialog(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle
            sx={{
              position: "relative",
              textAlign: "center",
              borderBottom: "1px solid #e0e0e0",
              pb: 1,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Atach / Detach
            </Typography>

            <IconButton
              onClick={() => {
                setSelectedPolicies([]);
                setOpenActionDetailsDialog(false);
              }}
              size="small"
              sx={{
                position: "absolute",
                right: 8,
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>

            <Box
              sx={{
                px: 1,
                py: 1,
                mt: 1,
                borderRadius: 1,
                fontSize: "0.85rem",
                fontFamily: "monospace",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              <ChipsSelectField
                handleAttach={(ids) => handleAttach(ids)}
                handleDetach={(ids) => handleDetach(ids)}
                isAttachDetach={true}
                label="Policies"
                placeholder="Select Policies"
                selectedValue={policyDefIds}
                setSelectedValue={setPolicyDefIds}
                listValues={selectedPolicies}
                setListValues={setSelectedPolicies}
                optionsList={(listOfPolicies || [])
                  ?.filter(
                    (item) =>
                      !(selectedPolicies || []).some(
                        (p) => p?.value === item?.policyId,
                      ),
                  )
                  ?.map((data) => ({
                    label: data?.policyName,
                    value: data?.policyId,
                    actions: data?.actions,
                  }))}
              />
            </Box>
          </DialogContent>

          <DialogActions
            sx={{
              borderTop: "1px solid #e0e0e0",
              pt: 1,
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
            }}
          >
            <CustomButtonV2
              type="cancel"
              btnName="Cancel"
              handleOnClick={() => setOpenActionDetailsDialog(false)}
            />
          </DialogActions>
        </Dialog>
      )}
      <CustomDialogBoxV2
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        title="Delete Role Type"
        successButtonName={"Ok"}
        rejectButtonName={"Cancel"}
        onClickReject={() => setOpenDeleteDialog(false)}
        actionButtonStyle={"continuous"}
        onClickSuccess={() => {
          dispatch(
            HandleApiActions({
              ...roletypeActions.deactivate_roletype,
              api_name: `/UCM/role-types/${selectedRoleType?.role_type_id}`,
              show_toast: true,
            }),
          ).then(fetchRoleTypes);
          setOpenDeleteDialog(false);
        }}
      >
        Are you sure you want to delete this role type?
      </CustomDialogBoxV2>
    </div>
  );
}

export default RoleType;
